const converters = {
  A: (e) => ({
    href: e.getAttribute('href'),
    target: e.getAttribute('target'),
  }),
}

const toAttrs = (content) => {
  let elem
  const range = document.createRange()
  const attrs = []
  const temp = document.createElement('div')
  document.body.appendChild(temp)
  temp.innerHTML = content

  while (elem) {
    elem = temp.firstElementChild
    const startIndex = elem.previousSibling
      ? elem.previousSibling.nodeValue.length
      : 0
    const type = elem.nodeName
    const length = elem.textContent.length
    // const elemContent = range.selectNodeContents(elem)
    const elemFrag = range.extractContents()
    const props = converters[type] ? converters[type](elem) : {}
    // call method here to get the attributes needed (aka href, src, etc)
    attrs.push({ type, startIndex, length, props })
    temp.replaceChild(elemFrag, elem)
    temp.normalize()
  }
  const html = temp.innerHTML
  temp.remove()
  return { content: html, attrs }
}

const getTextNodes = (node) => {
  const textNodes = []
  if (node.nodeType === 3) {
    textNodes.push(node)
  } else {
    const children = Array.from(node.childNodes)
    children.forEach((child) => {
      textNodes.push.apply(textNodes, getTextNodes(child))
    })
  }
  return textNodes
}
const setSelectionRange = (elem, start, length) => {
  const range = document.createRange()
  const end = start + length

  range.selectNodeContents(elem)
  const textNodes = getTextNodes(elem)

  let hasStart = false
  let currCount = 0
  let endCount = 0
  let i
  let textNode
  for (i = 0; i < textNodes.length; i++) {
    textNode = textNodes[i]
    endCount = currCount + textNode.length
    if (!hasStart && start >= currCount && start <= endCount) {
      hasStart = true
      range.setStart(textNode, start - currCount)
    }
    // no else if because start and end can be in same node
    if (hasStart && end <= endCount) {
      range.setEnd(textNode, end - currCount)
      break
    }
    currCount = endCount
  }

  // totally assuming match is there
  const selection = window.getSelection()
  selection.removeAllRanges()
  selection.addRange(range)
  return range
}

/* TAKES THE CONTENT AND ARRAY AND BUILDS HTML STRING */
const toElems = (content, attrs) => {
  const temp = document.createElement('div')
  temp.innerHTML = content
  document.body.appendChild(temp)
  attrs
    .sort((a, b) => (b.startIndex - a.startIndex ? 1 : -1))
    .reverse()
    .forEach((o) => {
      const range = setSelectionRange(temp, o.startIndex, o.length)
      const elem = document.createElement(o.type)
      Object.keys(o.props).forEach((k) => {
        if (o.props[k]) {
          elem[k] = o.props[k]
        }
      })
      const elemFrag = range.cloneContents()
      elem.appendChild(elemFrag)
      range.deleteContents()
      range.insertNode(elem)
      temp.normalize()
    })
  const html = temp.innerHTML
  temp.remove()
  return html
}

export const splitHTMLAtIndex = (html, offset) => {
  // So take the HTML String and turn into text with attributes
  const textAttrs = toAttrs(html)
  // Break up our string to the two halves
  const leadText = textAttrs.content.substr(0, offset)
  const tailText = textAttrs.content.substr(offset)
  // We will loop over the attributes and see if they still apply to the partial selections
  const leadAttrs = []
  const tailAttrs = []
  textAttrs.attrs.forEach((attr) => {
    // Figure out where the closing tag is located
    var end = attr.startIndex + attr.length
    // If the closing tag position is less than the offset, than we are golden, just copy it
    if (end <= offset) {
      leadAttrs.push(Object.assign({}, attr))
    } else {
      // than the closing tag is in the second half of the string
      // if the opening tag resides in the first half
      if (attr.startIndex < offset) {
        // Copy the object and adjust the length so it is closed at the end of the string
        const sA = Object.assign({}, attr)
        sA.length = offset - attr.startIndex
        // If the tag still has content than push it onto the stack
        if (sA.length > 0) {
          leadAttrs.push(sA)
        }
      }
      // Now we need to adjust the start and end of the closing tag
      const tA = Object.assign({}, attr)
      // move the indexes down since we chopped out the first portion
      tA.startIndex -= offset
      // if the start index is negative (opening tag was in first half), we adjust the length and  start locaiton
      if (tA.startIndex < 0) {
        tA.length += tA.startIndex
        tA.startIndex = 0
      }
      // If the tag still has characters, than push it onto the tail stack
      if (tA.length > 0) {
        tailAttrs.push(tA)
      }
    }
  })

  // Now that we have the attrs for the partials, we can convert it back to HTML
  return {
    lead: toElems(leadText, leadAttrs),
    tail: toElems(tailText, tailAttrs),
  }
}
